import { render, staticRenderFns } from "./BoardColumnSettingsModal.vue?vue&type=template&id=5032b71e&scoped=true"
import script from "./BoardColumnSettingsModal.vue?vue&type=script&lang=js"
export * from "./BoardColumnSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./BoardColumnSettingsModal.vue?vue&type=style&index=0&id=5032b71e&prod&scoped=true&lang=css"
import style1 from "./BoardColumnSettingsModal.vue?vue&type=style&index=1&id=5032b71e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032b71e",
  null
  
)

export default component.exports